import { motion } from 'framer-motion';
import { SERVICES } from '../data';

export default function Services() {
  return (
    <section id="services" className="section-pad relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-indigo-950/8 to-transparent pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <motion.div initial={{opacity:0,y:28}} whileInView={{opacity:1,y:0}}
          transition={{duration:0.55}} viewport={{once:true}} className="text-center mb-16">
          <p className="text-violet-400 font-mono text-xs tracking-[0.2em] uppercase mb-4">— What I Offer</p>
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            Services & <span className="grad-text">Expertise</span>
          </h2>
          <p className="text-slate-400 max-w-md mx-auto">From concept to deployment — I handle the full engineering stack</p>
        </motion.div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div key={s.title}
              initial={{opacity:0,y:36}} whileInView={{opacity:1,y:0}}
              transition={{duration:0.5,delay:i*0.08}} viewport={{once:true}}
              whileHover={{y:-8,scale:1.02}}
              className={`group relative glass rounded-3xl p-7 border ${s.border} bg-gradient-to-br ${s.bg} card-lift overflow-hidden`}
            >
              {/* Hover glow */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-violet-600/5 to-transparent pointer-events-none" />

              <div className="relative z-10">
                <span className="text-4xl mb-5 block group-hover:scale-110 transition-transform duration-300">{s.icon}</span>
                <h3 className="text-white font-bold text-xl mb-3 group-hover:text-violet-300 transition-colors">{s.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed mb-6">{s.desc}</p>
                <ul className="space-y-2">
                  {s.items.map(item => (
                    <li key={item} className="flex items-center gap-2 text-sm text-slate-400">
                      <span className="text-violet-500 flex-shrink-0">▸</span>{item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-6 pt-5 border-t border-white/[0.05]">
                <a href="#contact" className="text-sm text-violet-400 hover:text-violet-300 font-medium transition-colors flex items-center gap-2 group/link">
                  Inquire about this service
                  <span className="group-hover/link:translate-x-1 transition-transform">→</span>
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA banner */}
        <motion.div initial={{opacity:0,y:28}} whileInView={{opacity:1,y:0}}
          transition={{duration:0.55,delay:0.2}} viewport={{once:true}}
          className="mt-16 glass rounded-3xl p-10 border border-violet-500/15 text-center relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-violet-600/5 via-transparent to-cyan-600/5 pointer-events-none" />
          <div className="relative z-10">
            <h3 className="text-2xl sm:text-3xl font-black text-white mb-4">Have a project in mind?</h3>
            <p className="text-slate-400 mb-8 max-w-md mx-auto">
              Let's discuss your requirements and build something exceptional together.
            </p>
            <motion.a href="#contact" whileHover={{scale:1.05}} whileTap={{scale:0.97}}
              className="inline-flex items-center gap-2 px-8 py-4 font-bold text-white rounded-xl btn-primary neon-v">
              Start a Conversation →
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
